import {forwardRef, useRef, Ref, useImperativeHandle} from 'react';


import './GuiThemesHeader.scss'
import {Box, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {ClosePopupBtn} from "../../../../../../../../com/closePopupBtn/closePopupBtn";

const useStyles = makeStyles(() => ({
    guiThemeHeader: {
        background: `linear-gradient(89.41deg, #0198D2 0%, #3540A8 100%)`,
        display: `flex`,
        justifyContent: `space-between`,
        padding: `6px 20px`,
        cursor: "move"
    }
}))

export interface IGuiThemesHeaderRef {
    getRef(): HTMLDivElement;

    addEventListener<K extends keyof HTMLElementEventMap>(type: K, listener: (this: HTMLElement, ev: HTMLElementEventMap[K]) => any, options?: boolean | AddEventListenerOptions): void;

    removeEventListener(type: string, listener: EventListenerOrEventListenerObject, options?: boolean | EventListenerOptions): void;
}

interface IGuiThemesHeader {
    label: string;
    onClose: () => void;
}

// const GuiThemesHeader: React.FC<IGuiThemesHeader> = (props) => {
const GuiThemesHeader = forwardRef((props: IGuiThemesHeader, ref: Ref<IGuiThemesHeaderRef>) => {
    const classes = useStyles();
    let containerRef = useRef<HTMLDivElement>(null);

    useImperativeHandle(ref, () => ({getRef, addEventListener, removeEventListener}));

    function getRef(): HTMLDivElement {
        return containerRef.current!
    }

    function addEventListener<K extends keyof HTMLElementEventMap>(type: K, listener: (this: HTMLElement, ev: HTMLElementEventMap[K]) => any, options?: boolean | AddEventListenerOptions): void {
        containerRef.current?.addEventListener(type, listener)
    }

    function removeEventListener(type: string, listener: EventListenerOrEventListenerObject, options?: boolean | EventListenerOptions): void {
        containerRef.current?.removeEventListener(type, listener)
    }

    return (
        <Box
            className={classes.guiThemeHeader}
            draggable={true}
            ref={containerRef}
        >
            <Box sx={{
                display: `flex`,
                alignItems: `center`,
            }}>
                <Typography color={`#ffffff`} fontWeight={700}>
                    {props.label}
                </Typography>
            </Box>
            <ClosePopupBtn onClose={props.onClose}/>
        </Box>
    )
})

export default GuiThemesHeader